var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sound-group-container"},[_c('h3',{staticClass:"sound-group-description"},[_vm._v(_vm._s(_vm.description))]),_c('FilteredSentence'),_c('c-block-input',{attrs:{"value":_vm.exerciseValue},on:{"input":_vm.setInput}}),_c('c-next-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }